const formSelect = document.getElementById('employerregistrationform-80-ss_origin');
const inputTarget = document.getElementById('employerregistrationform-80-ss_origin_other');

export function EmployeeRegistration() {
  if (formSelect != null) {
    check_selection();
    formSelect.onchange = function () {
      check_selection();
    }
  }
}

EmployeeRegistration();

function check_selection() {
  const formGroup = <HTMLElement>inputTarget.closest(".form-group");
  if ((<HTMLInputElement>formSelect).value == "860530010") {
    formGroup.style.display = "block";
  } else {
    formGroup.style.display = "none";
  }
}
